import { Injectable, Type } from '@angular/core';

import { EventModel, EventScoreboard } from '@frontend/sports/betting-offer/feature/model';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { AnimationModule } from './animation.module';

export interface EventAnimationBinding {
    event: EventModel;
    scoreboard: EventScoreboard;
    inColumn?: boolean;
    isTerminal?: boolean;
    showSticky?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AnimationComponentLoaderService extends ComponentLoaderService<AnimationModule> {
    moduleName = 'AnimationModule';

    constructor(moduleLoader: ModuleLoaderService, loggerFactory: LoggerFactory) {
        super(moduleLoader, loggerFactory);
    }

    getAnimationComponent(): ComponentProxy<EventAnimationBinding> {
        return this.getComponentProxy<EventAnimationBinding>((module) => module.animationComponent, 'event-animations');
    }

    getModule(): Promise<Type<AnimationModule>> {
        return import('./animation.module').then((m) => m.AnimationModule);
    }
}
